// @flow
import React from 'react';
import { defaultProps } from 'recompose';
import styled, { css } from 'styled-components';
import { Icon } from './../core/Icon';
import { ICON_PATH } from './../../constants/path';
import { PlainIcon } from './PathIcon';
import HelpIcon from './../../assets/svgs/icons/icn-help.svg';
import HelpWhiteIcon from './../../assets/svgs/icons/icn-help-white.svg';
import HomeIcon from './../../assets/svgPath/icons/HomeIcon';
import ChatIcon from './../../assets/svgs/icons/icn-chat.svg';
import InboxIcon from './../../assets/svgs/icons/icn-inbox.svg';
import InboxWhiteIcon from './../../assets/svgs/icons/icn-inbox-white.svg';
import LikeIcon from './../../assets/svgPath/icons/LikeIcon';
import DownloadIcon from './../../assets/svgPath/icons/DownloadIcon';
import CartIcon from './../../assets/svgs/icons/icn-cart-new.svg';
import LogoBadgeInvertedIcon from './../../assets/svgs/icons/icn-logo-badge-inverted.svg';
import SellingIcon from './../../assets/svgs/icons/icn-selling.svg';
import SellingWhiteIcon from './../../assets/svgs/icons/icn-selling-white.svg';
import BuyingIcon from './../../assets/svgs/icons/icn-buying.svg';
import BuyingWhiteIcon from './../../assets/svgs/icons/icn-buying-white.svg';
import SigninWhiteIcon from './../../assets/svgs/icons/icn-signin-white.svg';
import SmiteCardIcon from './../../assets/svgs/icons/smite_card.svg';
import ConnectWithPaypalIcon from './../../assets/svgs/icons/connect_with_paypal.svg';
import BlueCheckIcon from './../../assets/svgs/icons/blue_check.svg';
import ChevronLeftIcon from './../../assets/svgs/icons/icn-chevron-left-grey.svg';
import ChevronRightIcon from './../../assets/svgs/icons/icn-chevron-right-grey.svg';
import MinusDarkIcon from './../../assets/svgs/icons/icn-minus-dark.svg';
import PlusDarkIcon from './../../assets/svgs/icons/icn-plus-dark.svg';
import ClockIcon from './../../assets/svgs/icons/icn-clock.svg';
import DashboardIcon from './../../assets/svgs/icons/icn-dashboard.svg';

// above code dont allow it to add style ie styled(ArrowIcon1)`width:50px` dont work
// defaultProps allows to add default value while allowing it to be styled as well pass props
// else have to https://github.com/styled-components/styled-components/issues/135#issuecomment-256018643

export {
  HelpIcon,
  HelpWhiteIcon,
  HomeIcon,
  ChatIcon,
  InboxIcon,
  InboxWhiteIcon,
  LikeIcon,
  CartIcon,
  LogoBadgeInvertedIcon,
  SellingIcon,
  SellingWhiteIcon,
  BuyingIcon,
  BuyingWhiteIcon,
  SigninWhiteIcon,
  SmiteCardIcon,
  ConnectWithPaypalIcon,
  BlueCheckIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  MinusDarkIcon,
  PlusDarkIcon,
  ClockIcon,
  DownloadIcon,
  DashboardIcon,
};

export const iconWithUri = (uri: string) => defaultProps({ uri })(Icon);

export const USPSIcon = iconWithUri('shipping/icn_carrier_usps.svg');
export const UPSIcon = iconWithUri('shipping/icn_carrier_ups.svg');
export const UPSGroundIcon = iconWithUri('shipping/icn_carrier_ups_ground.svg');
export const FedexIcon = iconWithUri('shipping/icn_carrier_fedex.svg');

export const BurgerIcon = iconWithUri('icn-burger.svg');
export const BurgerIconWite = iconWithUri('icn-burger-white.svg');
export const LogoBadgeIcon = iconWithUri('logo-badge.svg');
export const LogoBadgeWhiteIcon = iconWithUri('logo-badge-white.svg');
export const LogoDarkIcon = iconWithUri('logo-dark.svg');
export const LogoShieldIcon = iconWithUri('logo-shield.svg');
export const LogoShieldBlueIcon = iconWithUri('logo-shield-blue.svg');
export const SearchBlue4Icon = iconWithUri('icn-search-blue-4.svg');
export const SearchCancelIcon = iconWithUri('icn-search-cancel.svg');
export const InfoIcon = iconWithUri('icn-info.svg');
export const SearchIcon = iconWithUri('icn-search.svg');
export const SearchIconNew = iconWithUri('icn-search-new.svg');
export const SearchIconSteamInventory = iconWithUri(
  'icn-search-steam-inventory.svg',
);
export const SearchIconDg = iconWithUri('icn-search-dg.svg');
export const GreySearchIcon = iconWithUri('icn-search-grey.svg');
export const GreySearchIcon2 = iconWithUri('icn-search-grey-2.svg');
export const SavedSearchIcon = iconWithUri('icn-saved-search.svg');
export const CloseIcon = iconWithUri('icn-close.svg');
export const GreyCloseIcon = iconWithUri('icn-close-grey.png');
export const BlackCloseIcon = iconWithUri('icn-close-black.svg');
export const CloseCircleIcon = iconWithUri('icn-close-circle.svg');
export const MercariBlueCloseCircleIcon = iconWithUri(
  'icn-close-circle-mercari-blue.svg',
);
export const CloseCircleFilledIcon = iconWithUri('icn-close-circle-fill.svg');
export const ReportIcon = iconWithUri('icn-report.svg');
export const ReportCircleIcon = iconWithUri('icn-report-circle.svg');
export const SecureIconDesktop = iconWithUri('icn-secure-desktop.svg');
export const SocialShareIcon = iconWithUri('icn-social-share.svg');
export const CheckIcon = iconWithUri('icn-check-white.svg');
export const DigitalCheckIcon = iconWithUri('digital/icn-check.svg');
export const DashWhiteIcon = iconWithUri('icn-dash-white.svg');
export const SmallRightIcon = iconWithUri('icn-small-right.svg');
export const PaypalIcon = iconWithUri('icn-paypal.svg');
export const PlusIcon = iconWithUri('icn-plus.svg');
export const PlusActiveIcon = iconWithUri('icn-plus-active.svg');
export const PlusCircleIcon = iconWithUri('icn-plus-circle.svg');
export const KebabIcon = iconWithUri('icn-kebab.svg');
export const WarningIcon = iconWithUri('icn-warning.svg');
export const SuccessIcon = iconWithUri('icn-success.svg');
export const ErrorIcon = iconWithUri('icn-error.svg');
export const CSVIcon = iconWithUri('icn-csv.svg');
export const MinusIcon = iconWithUri('icn-minus.svg');
export const FreeShippingVanIcon = iconWithUri('icn-free_shipping_van.svg');
export const FreeShippingIcon = iconWithUri('icn-free-shipping-box.svg');
export const JPFlagIcon = iconWithUri('flag/icn-jp-flag.svg');
export const USFlagIcon = iconWithUri('flag/icn-us-flag.svg');
export const HotIcon = iconWithUri('icn-hot.svg');
export const CPSIcon = iconWithUri('icn-cps.svg');
export const CPSIconFull = iconWithUri('icn-cps-full.svg');
export const AngleLeftIcon = iconWithUri('icn-angle-left.svg');
export const SquareAngleRightIcon = iconWithUri('icn-square-angle-right.svg');
export const AngleRightIcon = iconWithUri('icn-angle-right.svg');
export const AngleGreyDownIcon = iconWithUri('icn-angle-grey-down.svg');
export const AngleGreyRightIcon = iconWithUri('icn-angle-grey-right.svg');
export const AngleWhiteDownIcon = iconWithUri('icn-angle-white-down.svg');
export const TooltipTriangleIcon = iconWithUri('icn-tooltip-triangle.svg');
export const DarkTooltipTriangleIcon = iconWithUri(
  'icn-tooltip-triangle-dark.svg',
);

export const FiveStarsIcon = iconWithUri('icn-five-stars.svg');
export const PayPalIcon = iconWithUri('icn-paypal.svg');
export const PinterestIcon = iconWithUri('social/pinterest.svg');
export const EmailIcon = iconWithUri('social/email.svg');
export const FacebookIcon = iconWithUri('social/facebook.svg');
export const TwitterIcon = iconWithUri('social/twitter.svg');
export const FacebookCircleIcon = iconWithUri('social/facebook-circle.svg');
export const TwitterCircleIcon = iconWithUri('social/twitter-circle.svg');
export const InstagramCircleIcon = iconWithUri('social/instagram-circle.svg');
export const YoutubeIcon = iconWithUri('social/youtube.svg');
export const HPCameraIcon = iconWithUri('icn-hp-camera.svg');
export const HPDollarIcon = iconWithUri('icn-hp-dollar.svg');
export const HPArrowIcon = iconWithUri('icn-hp-arrow.svg');
export const HPGetTheAppIcon = iconWithUri('icn-hp-get-the-app.svg');
export const GoldStarIcon = iconWithUri('gold-star.svg');
export const GoldStarIOSIcon = iconWithUri('gold-star-ios.svg');
export const GoldStarAndroidIcon = iconWithUri('gold-star-android.svg');
export const GetTheAppIcon = iconWithUri('get-the-app-2.svg');
export const MercariLogoIcon = iconWithUri('mercari-logo.svg');
export const MercariLogoRoundedIcon = iconWithUri('mercari-logo-rounded.svg');
export const MercariLogoWhiteIcon = iconWithUri('logo-white.svg');
export const MercariGgLogoIcon = iconWithUri('mercari-gg-logo.svg');
export const IOSRatingsIcon = iconWithUri('ios-ratings.svg');
export const AndroidRatingsIcon = iconWithUri('android-ratings.svg');
export const IOSRatingsBlueIcon = iconWithUri('ios-ratings-blue.svg');
export const AndroidRatingsBlueIcon = iconWithUri('android-ratings-blue.svg');
export const LikeBlueIcon = iconWithUri('like_blue.svg');
export const SoldOutBigIcon = iconWithUri('sold_out_big.svg');
export const CircleWhitePencilIcon = iconWithUri('icn-circle-pencil-white.svg');
export const CircleWhiteTrashcanIcon = iconWithUri(
  'icn-circle-trashcan-white.svg',
);

export const DGMercariShieldIcon = iconWithUri('dg/icn-mercari-shield.svg');
export const DGRightArrowIcon = iconWithUri('dg/icn-right-arrow.svg');
export const DGDownArrowIcon = iconWithUri('dg/icn-down-arrow.svg');
export const DGRightArrowWhiteIcon = iconWithUri(
  'dg/icn-right-arrow-white.svg',
);
export const DGSellItIcon = iconWithUri('dg/sell-it.svg');
export const DGCircleCashWhiteIcon = iconWithUri(
  'dg/icn-circle-cash-white.svg',
);
export const DGGetPaidIcon = iconWithUri('dg/get-paid.svg');
export const DGTradeItIcon = iconWithUri('dg/trade-it.svg');
export const DGSupportIcon = iconWithUri('dg/icn-support.svg');
export const DGGamePeripheralsGroupIcon = iconWithUri(
  'dg/game-peripherals-group.svg',
);
export const DGSteamIcon = iconWithUri('dg/icn-steam.svg');
export const DGSteamWhiteIcon = iconWithUri('dg/icn-steam-white.svg');
export const DGCircleBuyerIcon = iconWithUri('dg/icn-circle-buyer.svg');
export const DGCircleSellerIcon = iconWithUri('dg/icn-circle-seller.svg');
export const DGCircleCheckIcon = iconWithUri('dg/icn-circle-check.svg');
export const DGCircleDotIcon = iconWithUri('dg/icn-circle-dot.svg');
export const DGCircleSteamIcon = iconWithUri('dg/icn-circle-steam.svg');
export const DGCircleSteamWhiteIcon = iconWithUri(
  'dg/icn-circle-steam-white.svg',
);
export const DGCircleSwordIcon = iconWithUri('dg/icn-circle-sword.svg');
export const DGCircleLockIcon = iconWithUri('dg/icn-circle-lock.svg');
export const DGCircleTagIcon = iconWithUri('dg/icn-circle-tag.svg');
export const DGCircleLinksIcon = iconWithUri('dg/icn-circle-links.svg');
export const DGCircleControllerIcon = iconWithUri(
  'dg/icn-circle-controller.svg',
);
export const DGDottedLineIcon = iconWithUri('dg/icn-dotted-line.svg');
export const DGTipIcon = iconWithUri('dg/icn-tip.svg');

export const DGCartIcon = iconWithUri('dg/icn-cart-blue.svg');
export const DGStarIcon = iconWithUri('dg/icn-star-blue.svg');
export const DGShieldIcon = iconWithUri('dg/icn-shield-blue.svg');

export const DGWallStreetJournalIcon = iconWithUri(
  'dg/socialProof/wall_street_journal.svg',
);
export const DGTechCrunchIcon = iconWithUri('dg/socialProof/tech_crunch.svg');
export const DGCNBCIcon = iconWithUri('dg/socialProof/cnbc.svg');
export const DGBloombergIcon = iconWithUri('dg/socialProof/bloomberg.svg');
export const DGCheddarIcon = iconWithUri('dg/socialProof/cheddar.svg');

export const HomeGetPaidIcon = iconWithUri('home/get-paid.svg');
export const HomeSellItIcon = iconWithUri('home/sell-it.svg');
export const HomeShipItIcon = iconWithUri('home/ship-it.svg');
export const HomeArrowIcon = iconWithUri('home/arrow.svg');
export const NavSellIcon = iconWithUri('nav/sell-green.svg');
export const NavArrowIcon = iconWithUri('nav/arrow.svg');
export const BlueArrowIcon = iconWithUri('icn-blue-arrow.svg');
export const CNBCIcon = iconWithUri('socialProof/cnbc.svg');
export const TeenVogueIcon = iconWithUri('socialProof/teen_vogue.svg');
export const BritCoIcon = iconWithUri('socialProof/brit_co.svg');
export const WomensDayIcon = iconWithUri('socialProof/womens_day.svg');
export const VerifiedIcon = iconWithUri('icn-verified.svg');
export const BlueCameraIcon = iconWithUri('icn-camera-blue.svg');
export const LocationPinIcon = iconWithUri('icn-location-pin.svg');
export const PackageWeightIcon = iconWithUri('sell/icn-package-weight.svg');
export const MoneyBlueIcon = iconWithUri('sell/icn-money-blue.svg');
export const BoxShippedIcon = iconWithUri('sell/icn-box-shipped.svg');
export const ThumbsUpIcon = iconWithUri('sell/icn-thumbs-up.svg');
export const SortIcon = iconWithUri('icn-sort.svg');
export const BackIconShort = iconWithUri('icn-back-arrow-short.svg');
export const CouponIcon = iconWithUri('icn-coupon.svg');

export const UserCircleIcon = iconWithUri('icn-user-circle.svg');
export const CalendarCircleIcon = iconWithUri('icn-calendar-circle.svg');
export const TruckCircleIcon = iconWithUri('icn-truck-circle.svg');
export const RatingCircleIcon = iconWithUri('icn-rating-circle.svg');
export const SentIcon = iconWithUri('icn-sent.svg');

export const OrderStatusDoneIcon = iconWithUri(
  'orderStatus/icn-status-done.svg',
);
export const EmphasizedIcon = iconWithUri('orderStatus/icn-emphasized.svg');
export const OrderStatusShieldIcon = iconWithUri('orderStatus/icn-shield.svg');
export const IDCheckIcon = iconWithUri('icn-id-check.svg');
export const CopyIcon = iconWithUri('icn-copy.svg');
export const BlueHelpIcon = iconWithUri('icn-blue-help.svg');
export const CheckCircleIcon = iconWithUri('icon-check-circle.svg');

export const LuxAuthIcon = iconWithUri('icn-lux-auth.svg');
export const LuxTrustIcon = iconWithUri('icn-lux-trust.svg');
export const LuxBoostIcon = iconWithUri('icn-lux-boost.svg');
export const LuxWhiteIcon = iconWithUri('icn-lux-white.svg');
export const LuxBlueIcon = iconWithUri('icn-lux-blue.svg');
export const LuxHandbagIcon = iconWithUri('icn-lux-handbag.svg');
export const CertificateIcon = iconWithUri('icn-certificate.svg');

export const HeartOutlineIcon = iconWithUri('icn-heart-outline.svg');
export const EyeOutlineIcon = iconWithUri('icn-eye-outline.svg');
export const TimeOutlineIcon = iconWithUri('icn-time-outline.svg');
export const CheckOutlineIcon = iconWithUri('icn-check-outline.svg');

export const DiscordIcon = iconWithUri('icn-discord.svg');

export const SaveCircleGreyIcon = iconWithUri(
  'marketingBanner/icn-save-circle-grey.svg',
);
export const ShopCircleGreyIcon = iconWithUri(
  'marketingBanner/icn-shop-circle-grey.svg',
);
export const BuyerCircleGreyIcon = iconWithUri(
  'marketingBanner/icn-buyer-circle-grey.svg',
);

export const PriceDropIcon = (props: any) => (
  <Icon {...props} type="onboarding" uri="price_drop.svg" />
);

export const ArrowIcon = (props: any) => (
  <Icon {...props} uri="icn-arrow.svg" />
);

export const ArrowBlackIcon = (props: any) => (
  <Icon {...props} uri="icn-arrow-black.svg" />
);

export const ArrowUpIcon = (props: any) => (
  <Icon {...props} uri="icn-arrow-up.svg" />
);

export const ChevronUpIcon = (props: any) => (
  <Icon {...props} uri="icn-chevron-up.svg" />
);

export const DarkChevronUpIcon = (props: any) => (
  <Icon {...props} uri="icn-chevron-up-dark.svg" />
);

export const BlueChevronUpIcon = (props: any) => (
  <Icon {...props} uri="icn-chevron-up-blue.svg" />
);

export const OrangeChevronUpIcon = (props: any) => (
  <Icon {...props} uri="icn-chevron-up-orange.svg" />
);

export const SoldOutIcon = () => (
  <PlainIcon {...ICON_PATH.itemTag} fill="orange" />
);

export const PriceDroppedIcon = () => (
  <PlainIcon {...ICON_PATH.discountTag} fill="mercari-blue" />
);

export const BackArrowIcon = (props: any) => (
  <PlainIcon {...ICON_PATH.backArrow} fill="black" {...props} />
);

export const CancelIcon = (props: any) => (
  <PlainIcon {...ICON_PATH.cancel} fill="white" {...props} />
);

export const MessageIcon = (props: any) => (
  <PlainIcon
    {...ICON_PATH.chat}
    stroke="white"
    fill="transparent"
    centerAlign={false}
    {...props}
  />
);

export const ReportCircleFilledIcon = (props: any) => (
  <PlainIcon {...ICON_PATH.flag} fill="grey-5" centerAlign={false} {...props} />
);

export const AlertCircleFilledIcon = (props: any) => (
  <PlainIcon {...ICON_PATH.alert} fill="red-2" centerAlign={false} {...props} />
);

export const SuccessCircleFilledIcon = (props: any) => (
  <PlainIcon
    {...ICON_PATH.success}
    fill="green-3"
    centerAlign={false}
    {...props}
  />
);

const chevronAnimation = css`
  cursor: ${props => props.cursor || 'pointer'};
  transition: ${props =>
    props.animation || 'transform 0.3s cubic-bezier(0.4, 0, 0.6, 1.55)'};
  user-select: none;
`;
export const AnimatedChevronUpIcon = styled(ChevronUpIcon)`
  ${chevronAnimation}
`;

export const AnimatedChevronUpDarkIcon = styled(DarkChevronUpIcon)`
  ${chevronAnimation}
`;

export const DgAnimatedChevronUpIcon = styled(BlueChevronUpIcon)`
  ${chevronAnimation}
`;

export const AnimatedHomeArrowUpIcon = styled(HomeArrowIcon)`
  ${chevronAnimation}
`;

export const HomeArrowMercariBlueIcon = iconWithUri(
  'home/arrow-mercari-blue.svg',
);

export const UpArrowOrange = iconWithUri('lp-template/up-arrow-orange.svg');
export const DiscountOrange = iconWithUri('lp-template/discount-2-orange.svg');
export const ScaleOrange = iconWithUri('lp-template/scale-orange.svg');
export const LightBulbOrange = iconWithUri('lp-template/lightbulb-orange.svg');
export const LuxOrange = iconWithUri('lp-template/lux-orange.svg');
export const PayByCard = iconWithUri('lp-template/pay-by-card.svg');
export const LockClosed = iconWithUri('lp-template/lock-closed.svg');
export const NoExtraCost = iconWithUri('lp-template/no-extra-cost.svg');
export const BoxShippedIcon2 = (props: any) => (
  <Icon {...props} uri="sell/icn-box-shipped.svg" />
);
